import { memo, useMemo } from 'react';
import * as THREE from 'three';

type Props = {
  url?: string;
};

const Product = ({ url = '/paranoma/wood.jpg' }: Props) => {
  const texture = useMemo(() => new THREE.TextureLoader().load(url), []);

  return (
    <mesh>
      <sphereBufferGeometry args={[10, 100, 100]} />
      <meshBasicMaterial map={texture} side={THREE.DoubleSide} />
    </mesh>
  );
};

export default memo(Product);
